export const USER_SEC_CHECK = "USER_SEC_CHECK";
export const USER_LOGGED_IN = "USER_LOGGED_IN";
export const USER_LOGGED_OUT = "USER_LOGGED_OUT";
export const USER_SESSION_EXPIRED = "USER_SESSION_EXPIRED";
export const USER_GLB = "USER_GLB";
export const SEARCH_UI_LOADED = "SEARCH_UI_LOADED";
export const SEARCH_UI_UNABLE_TO_LOAD = "SEARCH_UI_UNABLE_TO_LOAD";
export const HOME_VALUE_FETCHED = "HOME_VALUE_FETCHED";
export const NAV_CHANGED = "NAV_CHANGED";
export const NAV_ITEM_COUNT = "NAV_ITEM_COUNT";
export const NAV_INITIALIZE = "NAV_INITIALIZE";
export const NAV_ADD_LIST_ITEM = "NAV_ADD_LIST_ITEM";
export const ADD_ITEM_TO_PROGRESS_LIST = "ADD_ITEM_TO_PROGRESS_LIST";
export const REMOVE_ITEM_FROM_PROGRESS_LIST = "REMOVE_ITEM_FROM_PROGRESS_LIST";
export const CLEAR_PROGRESS_LIST = "CLEAR_PROGRESS_LIST";
export const SET_CANCEL_SOURCE = "SET_CANCEL_SOURCE";
export const RESET_CANCEL_SOURCE = "RESET_CANCEL_SOURCE";
export const SET_APP_ERROR_MESSAGE = "SET_APP_ERROR_MESSAGE";
export const RESET_APP_ERROR_MESSAGE = "RESET_APP_ERROR_MESSAGE";
export const ADD_USER_ACCOUNT = "ADD_USER_ACCOUNT";
export const ADD_ITEM_TO_STATES_LIST = "ADD_ITEM_TO_STATES_LIST";
export const REMOVE_ITEM_FROM_STATES_LIST = "REMOVE_ITEM_FROM_STATES_LIST";
export const CLEAR_STATES_LIST = "CLEAR_STATES_LIST";
export const SET_USER_DISCLOSURES = "SET_USER_DISCLOSURES";
export const REMOVE_USER_DISCLOSURES = "REMOVE_USER_DISCLOSURES";
export const ADD_ITEM_TO_CITIES_LIST = "ADD_ITEM_TO_CITIES_LIST";
export const REMOVE_ITEM_FROM_CITIES_LIST = "REMOVE_ITEM_FROM_CITIES_LIST";
export const CLEAR_CITIES_LIST = "CLEAR_CITIES_LIST";
export const SET_USER_CASES = "SET_USER_CASES";
export const REMOVE_USER_CASES = "REMOVE_USER_CASES";
export const SET_USER_CASE_CHARGES = "SET_USER_CASE_CHARGES";
export const REMOVE_USER_CASE_CHARGES = "REMOVE_USER_CASE_CHARGES";
export const SET_DPPA = "SET_DPPA";
export const REMOVE_DPPA = "REMOVE_DPPA";
export const SET_STATE = "SET_STATE";
export const REMOVE_STATE = "REMOVE_STATE";



// WEBPACK FOOTER //
// ./src/types.js